/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApp } from '@/routes/base';

/**
 * Chemin de la fiche d'un PACS : `/projets/[id]` pour un projet,
 * `/pacs/[id]` sinon.
 */
const getFichePacsPath = (
  identifiant: number | string | null | undefined,
  projet?: boolean,
) => `${baseUrlApp}${projet ? 'projets' : 'pacs'}/${identifiant}`;

export default getFichePacsPath;
